import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = "";

export const { thunk: getFile, slice: getFileSlice } = getThunkAndSlice<{ fileName: string }, typeof initialState>({
	initialState,
	path: "/api/System/GetFile",
});
